<div class="user-image-outer"
     (click)="stopPropagation($event)">
  <div class="user-image-container"
       [ngClass]="{'isCircle': isCircle}"
       style="position: relative;"
       [style.width]="size"
       [style.height]="size">

    @if (loadUserImageServiceStatus === ServiceStatus.loading && !profileUrl) {
    <div class="spinner-container">
      <mat-spinner class="user-image-spinner" [diameter]="spinnerDiameter"></mat-spinner>
    </div>
    }

    @if (showInitials && loadUserImageServiceStatus !== ServiceStatus.loading) {
    <div class="initials-avatar"
         [ngClass]="{'clickable': profileEnabled, 'isCircle': isCircle}"
         [style.background-color]="initialsColor"
         (click)="clickImage()">
      <span class="initials-text">{{initials}}</span>
    </div>
    }

    @if (profileUrl) {
    <img [src]="profileUrl"
         class="user-image-element"
         [ngClass]="{'clickable': profileEnabled}"
         (click)="clickImage()"
         (error)="handleImageError($event)" />
    }

    @if (loadUserImageServiceStatus === ServiceStatus.error) {
    <div class="error-container">
      <i class="icon-alert-triangle icon-alert" style="width: 24px; height: 24px;"></i>
    </div>
    }
  </div>

  @if (showOnlineStatus && profileUrl) {
    <div class="status-indicator heartbeat"
         [ngClass]="{'online': isUserOnline()}"
         [style.width.px]="statusDotSize"
         [style.height.px]="statusDotSize"></div>
  }
</div>

<!-- Profile dialog rendered via the shared adaptive (Material) dialog, composing the
     existing header + body templates so it shares the app's dialog overlay stack. -->
<ng-template #profileDialog>
  <div mat-dialog-title class="profile-dialog-title">
    <ng-container *ngTemplateOutlet="header"></ng-container>
    <button class="btn btn-icon profile-dialog-close" type="button" aria-label="Close" (click)="closePopup()">
      <i class="icon-x icon-header-blue"></i>
    </button>
  </div>
  <mat-dialog-content>
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </mat-dialog-content>
</ng-template>

<ng-template #header>
  <div class="popup-profile-header">
    <div class="popup-profile-picture-container" [class.deleted-user-photo]="userData?.IsDeleted">
      <user-image [userId]="displayUserId" [profileEnabled]="false" [size]="'72px'"></user-image>

      @if (isGuardian && currentUser?.UserType === 'Staff'){
      <button type="button" class="edit-icon-btn"
              [matMenuTriggerFor]="editMenu"
              [disabled]="flagStatus === ServiceStatus.loading"
              aria-label="Edit Profile">
        @if (flagStatus !== ServiceStatus.loading) {
        <i class="icon-broken-image icon-white" style="width: 16px; height: 16px;"></i>
        }
        @if (flagStatus === ServiceStatus.loading) {
        <mat-spinner [diameter]="16"></mat-spinner>
        }
      </button>

      <!-- Dropdown Menu For Image Options -->
      <mat-menu #editMenu="matMenu">
        @if (userData?.HasProfilePhoto){
        <button type="button" mat-menu-item (click)="openFormModal()">
          <i class="icon-circle-x icon-text-blue" style="width: 16px; height: 16px; margin-right: 8px;"></i>
          <span>Flag Profile Picture</span>
        </button>
        }
        <button type="button" mat-menu-item (click)="openViewFlagsModal()">
          <i class="icon-clipboard-list icon-text-blue" style="width: 16px; height: 16px; margin-right: 8px;"></i>
          <span>View Previous Flags</span>
        </button>
      </mat-menu>
      }

    </div>
    <div class="popup-profile-summary-container">
      @if (userDataServiceStatus === ServiceStatus.loaded && userData) {
      <div class="popup-profile-name">
        <h2 [class.text-header-blue]="!userData.IsDeleted"
            [class.deleted-user-name]="userData.IsDeleted"
            stlye="margin: 0;">{{userData.FirstName + ' ' + userData.LastName}}</h2>
      </div>
      @if (userData.IsDeleted) {
      <div class="popup-profile-deleted-note">
        @if (userData.UserType === 'Staff') {
        <small rtI18n>No longer an employee</small>
        } @else {
        <small rtI18n>No longer active</small>
        }
      </div>
      } @else {
      <div class="popup-profile-school">
        <i class="icon-office icon-action-blue" style="width: 16px; height: 16px; margin-right: 5px;"></i>
        <p class="text-text-blue" style="margin: 0;"><small>{{userData.SchoolName}}</small></p>
      </div>
      <div class="popup-profile-title">
        <p class="text-text-blue" style="margin: 0;"><small>{{getUserTitle()}}</small></p>
      </div>
      }
      }
    </div>
  </div>
</ng-template>
<ng-template #body>
  @if (userDataServiceStatus === ServiceStatus.loading) {
  <mat-spinner class="user-image-spinner">
  </mat-spinner>
  }
  @if (userDataServiceStatus === ServiceStatus.loaded && userData) {
  <div class="popup-directory-bottom">
    @if ((isStaff || isGuardian) && userData.Bio && userData.Bio !== 'No bio available.') {
    <div class="popup-about">
      <div>
        <p class="text-text-blue" style="margin: 0;"><small>About</small></p>
      </div>
      <div>
        <p class="text-text-blue" style="margin: 0;">{{ userData.Bio }}</p>    
      </div>
    </div>
    }
    <div class="popup-email" *ngIf="canShowEmail && !isStaff">
      <a class="text-action-blue" href="mailto:{{userData.Email}}">{{userData.Email}}</a>
      <button type="button" class="btn btn-icon" style="padding: 0; position: relative;" (click)="copyToClipboard(userData.Email)">
        <i class="icon-copy icon-action-blue"></i>
      </button>
      @if (emailCopied) {
      <div class="copied-message">
        <p><small><strong>email copied</strong></small></p>
      </div>
      }
    </div>
    @if (isStaff || isGuardian) {
    <div class="popup-availability text-text-blue">
      @if (userData.Availability) {
      <p style="margin: 0;">Availability: <strong>{{userData.Availability}}</strong></p>
      }
      @if (isStaff) {
        @if (alternativeContact) {
        <p style="margin: 0;">
          Alt. Contact: <a class="text-action-blue alternate-link" style="cursor: pointer" (click)="$event.stopPropagation(); openAltContactCard(alternativeContact.Id)">
            {{alternativeContact.FirstName + ' ' + alternativeContact.LastName}}
          </a>
        </p>
        }
        @if (!alternativeContact && userData.SupervisorUserId) {
        <p style="margin: 0;">
          Alt. Contact: <a class="text-action-blue alternate-link" style="cursor: pointer" (click)="$event.stopPropagation(); openAltContactCard(userData.SupervisorUserId)">
            {{userData.SupervisorFirstName + ' ' + userData.SupervisorLastName}}
          </a>
        </p>
        }
      }
    </div>
    }
    @if (isGuardian || isStudent) {
    <div class="student-guardians">
      @if (isGuardian) {
      <div>
        <p class="text-text-blue" style="margin: 0;"><small>Students</small></p>
        @if (getStudentsServiceStatus === ServiceStatus.loading) {
        <mat-spinner [diameter]="16"></mat-spinner>
        }
        @if (getStudentsServiceStatus === ServiceStatus.error) {
        <div class="error-container">
          <p style="margin: 0;" i18n>There was an error loading students.</p>
          <button type="button" class="btn btn-icon" (click)="getStudentsForGuardian()"><i class="icon-refresh icon-action-blue"></i></button>
        </div>
        }
        @if (getStudentsServiceStatus === ServiceStatus.loaded && userData && userData.Students) {
        <ng-content>
          @for (student of userData.Students; track student) {
          <div class="form-item">
            <p class="text-header-blue" style="margin: 0;">{{student.StudentFirstLastName}}</p>
          </div>
          }
        </ng-content>
        }
      </div>
      }
      @if (isStudent) {
      <div>
        <p class="text-text-blue" style="margin: 0;"><small>Parents</small></p>
        @if (getGuardiansServiceStatus === ServiceStatus.loading) {
        <mat-spinner [diameter]="16"></mat-spinner>
        }
        @if (getGuardiansServiceStatus === ServiceStatus.error) {
        <div class="error-container">
          <p style="margin: 0;" i18n>There was an error loading parents.</p>
          <button type="button" class="btn btn-icon" (click)="getGuardiansForStudent()"><i class="icon-refresh icon-action-blue"></i></button>
        </div>
        }
        @if (getGuardiansServiceStatus === ServiceStatus.loaded && userData && userData.Guardians) {
        <ng-content>
          @for (guardian of userData.Guardians; track guardian) {
          <div class="form-item">
            <p class="text-header-blue" style="margin: 0;">{{guardian.GuardianFirstLastName}} &middot; <span><small><i>{{guardian.RelationshipToStudent}}</i></small></span></p>
          </div>
          }
        </ng-content>
        }
      </div>
      }
    </div>
    }
    <div class="popup-buttons">
      @if (canMessageUser()) {
        <button type="button" class="btn btn-primary" (click)="routeToMessages(displayUserId); closePopup(); $event.stopPropagation()" i18n>Message</button>
      }
      @if (canViewChats()) {
        <button type="button" class="btn btn-secondary" (click)="routeToAdminMessages(displayUserId); $event.stopPropagation()" rtI18n>View Chats</button>
      }
      @if (canShowPhone && userData.Phone !== null && userData.Phone.length > 0 && userData.Phone !== 'N/A' && userData.Phone !== '0') {
      <a class="btn btn-secondary" [href]="'tel:' + userData.Phone" [attr.data-called-user-id]="userData.Id">{{formatPhoneNumber(userData.Phone)}}</a>
      }
    </div>
  </div>
  }

  @if (userDataServiceStatus === ServiceStatus.error) {
  <div>
    <div class="popup-directory-bottom">
      <div class="popup-error">
        <p>There was an error loading the user data.</p>
        <p>Please try again later.</p>
      </div>
    </div>
  </div>
  }
</ng-template>


<ng-template #flagHistoryDialog>
  <div class="dialog-header">
    <h3>Discipline History</h3>
    <button class="btn btn-icon" type="button" aria-label="Close" mat-dialog-close>
      <i class="icon-x icon-header-blue"></i>
    </button>
  </div>
  <mat-dialog-content>
  <div class="view-outer">
    <kendo-grid [data]="flags"
                [loading]="flagStatus === ServiceStatus.loading">
      <kendo-grid-messages pagerItems="flags"
                           noRecords="This user has no discipline history">
      </kendo-grid-messages>
      <kendo-grid-column field="CreatedDateUTC"
                         title="Flag Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.CreatedDateUTC | nhaDate}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="CreatedByUserName"
                         title="Flagged By">

      </kendo-grid-column>
      <kendo-grid-column field="Notes"
                         title="Notes">

      </kendo-grid-column>
    </kendo-grid>
  </div>
  </mat-dialog-content>
</ng-template>

<ng-template #flagFormDialog>
  <div class="dialog-header">
    <h3>Flag Photo</h3>
    <button class="btn btn-icon" type="button" aria-label="Close" mat-dialog-close>
      <i class="icon-x icon-header-blue"></i>
    </button>
  </div>
  <mat-dialog-content>
  <form [formGroup]="flagForm"
        (ngSubmit)="flagUser()">
    <div class="form-outer">
      <div class="form-image-container">
        <user-image [userId]="userData?.Id ?? 0"
                    [size]="'86px'"
                    [forceShowProfileImage]="true"
                    [profileEnabled]="false">

        </user-image>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea formControlName="Notes" matInput maxlength="255"></textarea>
      </mat-form-field>
      <mat-checkbox formControlName="CreateTicket">Create ticket for Parent Relations team</mat-checkbox>
      <button type="submit" [disabled]="flagStatus === ServiceStatus.loading" class="btn btn-primary" i18n>Create Flag</button>
    </div>
  </form>
  </mat-dialog-content>
</ng-template>
